import { Component } from '@angular/core';

@Component({
	selector: 'app-migration',
	templateUrl: './migration.component.html',
})
export class MigrationComponent {}
